import PropTypes from 'prop-types';

export const dynamicShelfPT = PropTypes.arrayOf(PropTypes.exact({
  products: PropTypes.array,
  shop_link: PropTypes.string,
  title: PropTypes.string,
}));
